import React from 'react';
export default function GetVTTTrack(item, index) {
    return (React.createElement(React.Fragment, { key: index }, item.stripClassName == 'custom.VTT' &&
        React.createElement("track", { kind: item.fields.kind ? item.fields.kind : '', src: "", srcLang: item.fields.lang ? item.fields.lang : '', label: item.fields.label ? item.fields.label : '', default: true })));
}
